<template>
    <el-container>
       <img class="banner" src="../assets/img/business-child.jpg">
       <el-page-header @back="goBack"  >
        </el-page-header>
       <div class="bg-box">
           <span>
               <div class="title">{{servceList[indexF].title}}</div>
               <el-divider></el-divider>
               <div class="text">{{servceList[indexF].text}}</div>
           </span>
       </div>
    </el-container>
</template>

<script>
export default {
    name:'business-detail',
    data() {
        return {
            indexF:0,
            servceList:[
               {
                   title:'健康服务',
                   text: '重疾后，和谐健康提供高额保险金，医疗机构提供医疗与疾病管理服务；保险金可直接支付就诊治疗费用、和后期健康维护费用；为客户提供健康维护与治疗所需的保险金；为患者提供优质医疗服务与疾病管理服务；'
               },
               {
                   title:'产品服务',
                   text: '我们所合作的保险公司累计拥有全系列保障产品300余款，其中包括：少儿保障类、医疗费用类、重疾保障类以及特定疾病保障类；同时我们将以保障客户利益的产品为主，为客户选择适合的产品，满足客户对于长期、稳定投资回报的产品需求；'
               },
               {
                   title:'需求服务',
                   text: '福保经纪拟合作的保险公司类别有：寿险公司、财险公司及养老险公司，同时有专业的三高团队为客户提供一对一的需求导向型的解决方案式服务，服务是我们持续发展的展示方式，服务虽然是公司向客户提供的行为内容，但却是客户最先接触并表达情感和意见的重要信息回馈途径，我们永远把目光聚焦在服务上并力争极致'
               },
               {
                   title:'外部服务',
                   text: '服务的维度首要则是“外部服务”，即：以“换位思考、真诚、满足”建设面向公司客户的外部服务。福保经纪将以寿险“个险销售”为未来的发展方向，配合企业的财产险、团体意外险、健康医疗保险产品为主营业务，秉承“以客户为中心，全心为客户服务”的宗旨。'
               },
               {
                   title:'内部服务',
                   text: '服务的另一个维度是内部服务，即：以“效率、结果、友情”建设面向公司同事的内部服务，我们将秉承公司的“执行理念”，即：今天的事今天办，重要的事优先办，限时的事按时办，能办的事马上办，困难的事努力办，琐碎的事抽空办，份外的事协助办，所有的事认真办。以此打造一批高效专业的内勤队伍，全面提升客户服务满意度。'
               },
               {
                   title:'产品设计',
                   text: '经纪公司相当于保险中介，和保险公司合作，给客户定制保险方案，推荐产品。经纪公司的业务涉及范围很广：人身险、车险、财产险、再保险等，大部分保险公司有的业务我们有。并且经纪公司和保险公司的最大的区别就是自己虽然不生产保险，但是可以根据客户需求，参与设计保险产品！'
               },
                {
                   title:'再保险',
                   text: '经纪公司还有另一个优势，是保险公司不具备的，即：经纪公司可以做再保险业务。我们将从客户服务风险管理方案为依托，建立健全保险经纪人业务流程，根据客户的委托需求为客户匹配承保保险公司，推荐、组合、定制化风险管理方案组合方式提供全流程服务产品，并配合客户弯沉投保手续，同时建立售后服务档案管理服务。'
               },
           ],
        };
    },
    components: {
    },
    created(){
        this.$nextTick(()=>{
            if(this.$route.query.indexF){
                this.indexF = this.$route.query.indexF
                window.scrollTo(0,0);
            }
        })
    },
   
    computed:{
        
    },
    methods:{
        goBack() {
            this.$router.push('/business')
        }
    },
}
</script>
<style lang="scss" scoped>
/deep/ .el-page-header{
    height: 30px;
    margin-left: 10%
}
/deep/ .el-page-header__left{
    width: 100%;
    align-items: center;
}
/deep/ .el-icon-back{
    font-size: $font-size-lv3;
}
/deep/ .el-page-header__title{
    font-size: $font-size-lv4;
}
.el-container{
    flex-wrap: wrap;
}
.banner{
    margin-bottom: 10px;
    width: 100%;
    height: 500px;
}
.bg-box{
    width: 100%;
    height: 1320px;
    display: flex;
    margin: 45px  10% 0 10%;
    position: relative;
    
        span{
            width: 100%;
            .title{
                text-align: left;
                 font-size: $font-size-lv2;
            }
            .text{
                text-align: left;
                font-size: $font-size-lv3;
                color: $font-color-gary1;
                line-height: 34px;
            }
        }
    }



</style>


// WEBPACK FOOTER //
// src/views/business-detail.vue